"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationHelper = void 0;
const Forms_1 = require("../../Forms");
class ValidationHelper {
    constructor() {
        this.getValidatedState = (inputs, formFields, isPersonalUserType, isLanguageFieldShown, currState, businessFields = {}) => {
            const newState = {};
            this.validateRequiredFields(inputs, formFields, businessFields, isPersonalUserType, isLanguageFieldShown, currState, (controlName, inputState) => {
                newState[controlName] = Object.assign({}, inputState);
                newState[controlName].hasError = true;
            });
            this.validateConsentCheckbox(currState, () => {
                newState.checkbox = Object.assign({}, currState.checkbox);
                newState.checkbox.hasError = true;
            });
            const emailInput = currState[formFields.email];
            const isEmailFieldWithRequiredError = 
            // eslint-disable-next-line no-prototype-builtins
            newState.hasOwnProperty(formFields.email) && newState[formFields.email].hasError;
            if (isEmailFieldWithRequiredError) {
                newState[formFields.email].hasFormatError = false;
            }
            else if (!(0, Forms_1.validateEmail)(emailInput.value)) {
                newState[formFields.email] = Object.assign({}, emailInput);
                newState[formFields.email].hasError = true;
                newState[formFields.email].hasFormatError = true;
                newState[formFields.email].hasInfoEmailError = false;
            }
            else if ((0, Forms_1.validateInfoEmail)(emailInput.value)) {
                newState[formFields.email] = Object.assign({}, emailInput);
                newState[formFields.email].hasError = true;
                newState[formFields.email].hasFormatError = true;
                newState[formFields.email].hasInfoEmailError = true;
            }
            return newState;
        };
        this.validateRequiredFields = (inputs, formFields, businessFields, isPersonalUserType, isLanguageFieldShown, currState, callback) => {
            const skipBusinessControl = (controlName) => {
                return isPersonalUserType && businessFields[controlName];
            };
            const skipLanguageControl = (controlName) => {
                return controlName === formFields.language && !isLanguageFieldShown;
            };
            const isControlValueEmpty = (value) => value.length === 0 || !value.trim();
            inputs.forEach(control => {
                const controlName = control.name;
                const inputState = currState[controlName];
                if (skipBusinessControl(controlName) || skipLanguageControl(controlName)) {
                    return;
                }
                if (control.required && isControlValueEmpty(inputState.value)) {
                    callback(controlName, inputState);
                }
            });
        };
        this.validateConsentCheckbox = (currState, callback) => {
            if (!currState.checkbox.isSelected) {
                callback();
            }
        };
    }
}
exports.validationHelper = new ValidationHelper();
